import {Component, OnInit, OnDestroy, PipeTransform, Pipe} from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import { Banner } from './banner.model';
import {Subscription} from 'rxjs';
import { BannersService } from './banners.service';
import { AuthService } from '../shared/auth/auth.service';

@Component({
  selector: 'banners',
  styleUrls: ['banners.component.css'],
  templateUrl: './banners.component.html'
})
export class BannersComponent implements OnInit, OnDestroy {
 paramSub: Subscription;
 banners: Banner[];
 view:string;
 brandId:string;
 categoryId:string;
 splitItems: string[];
 splitItem: string;
 valueId: string;
 newLink : string;
 showBannersFlag : boolean = false;

 siteIDs: string = "";

 bg_image = "/assets/images/banners/bg/test6.png";
   config: any = {
    pagination: '.swiper-pagination',
    paginationClickable: true,
    nextButton: '.swiper-button-next',
    prevButton: '.swiper-button-prev',
    slidesPerView: 1,
    slidesPerColumn: 1,
    spaceBetween: 10,
    autoplay: 5000, 
    autoplayDisableOnInteraction: false

  };
 constructor(public _authService: AuthService,private _route: ActivatedRoute,
              private _router: Router,
              private bannersService: BannersService) {
  }

   ngOnInit() {
 this.paramSub = this._route.params.subscribe(params => {


      // this.view = params['view'];
      // this.brandId = params['brandId'];
      // this.categoryId = params['categoryId'];
      // console.log('value for view' + this.view);
      //  console.log('value for brandId' + this.brandId);
      //   console.log('value for brandId' + this.categoryId);

      this.siteIDs = "4,2";

      this.bannersService.getBanners(this.siteIDs).subscribe(
          banners => {
            this.banners = banners;
            console.log("inside this.bannersService.getBanners()");
            
           
            for(var i = 0; i < this.banners.length ; i++){
              this.banners[i].vLink
              
              this.banners[i].vLink = this.getNewLink(this.banners[i].vLink);
            }

            //this.getNewLink('http://www.itherapeutics.com.au/page.jsp?p=iRewards&rewId=107');
            //this.getNewLink('http://www.itherapeutics.com.au/page.jsp?p=Training&enrolRef=_brand&view=Brand&brandID=31');
            
            console.log(banners);


          },
          err => {
            console.log(err);
          });
 });

 this.showBannersFlag = true;

 }

   ngOnDestroy() {
   // this.paramSub.unsubscribe();
  }

  getNewLink(originalLink: string){

    originalLink = originalLink.trim();
    console.log('Old Link ' + originalLink);
    this.splitItem = null;
    this.splitItems = null;
    this.newLink="";
    if(originalLink != "" && originalLink != undefined && originalLink != null){
      
      // if(originalLink.match('/\?/'))
      // this.splitItems =  originalLink.split('/\?/', -1);

    //  if(originalLink.match('?'))
    this.splitItems =  originalLink.split('?', -1);

    
    console.log('original Split ' + this.splitItems);
    console.log('original Split length ' + this.splitItems.length);
    console.log('original Split value |' + this.splitItems + "|");
    if(this.splitItems != null && this.splitItems != undefined ){
    if(this.splitItems.length > 0 && (this.splitItems[1].trim() != "" || this.splitItems[1].trim() != undefined )){
      this.splitItem = this.splitItems[1];
      if(this.splitItem.match('scoID')){
          
        console.log(this.splitItem.match('scoID'));
        this.splitItems=this.splitItem.split('&');
        
        for (let item of this.splitItems){
          if(item.match('scoID')){
            this.splitItems = item.split('scoID=');

            this.splitItem = this.splitItems[1];

            console.log('scoID splitted ' + this.splitItem);

            let pattern = new RegExp("[0-9]");
            console.log('pattern match' + pattern.test(this.splitItem));

            if(pattern.test(this.splitItem)){
              this.valueId = this.splitItem;
              console.log('value ID ' + this.valueId);

              this.newLink = "/enroltomodule;iModuleID=" + this.valueId + ";view=enrol"
              console.log('newLink ' + this.newLink);
            }


            console.log( item.split('scoID='));
          }
        }
        
          
      }
      else if (this.splitItem.match('rewId')){

        console.log(this.splitItem.match('rewId'));
        this.splitItems=this.splitItem.split('&');
        
        for (let item of this.splitItems){
          if(item.match('rewId')){
            this.splitItems = item.split('rewId=');

            this.splitItem = this.splitItems[1];

            console.log('rewId splitted ' + this.splitItem);

            let pattern = new RegExp("[0-9]");
            console.log('pattern match' + pattern.test(this.splitItem));

            if(pattern.test(this.splitItem)){
              this.valueId = this.splitItem;
              console.log('value ID ' + this.valueId);

              this.newLink = "/competitions;rewardId=" + this.valueId;
              console.log('newLink ' + this.newLink);
            }


            console.log( item.split('rewId='));
          }
        }


      }else if (this.splitItem.match('brandID')){

        console.log(this.splitItem.match('brandID'));
        this.splitItems=this.splitItem.split('&');
        
        for (let item of this.splitItems){
          if(item.match('brandID')){
            this.splitItems = item.split('brandID=');

            this.splitItem = this.splitItems[1];

            console.log('brandID splitted ' + this.splitItem);

            let pattern = new RegExp("[0-9]");
            console.log('pattern match' + pattern.test(this.splitItem));

            if(pattern.test(this.splitItem)){
              this.valueId = this.splitItem;
              console.log('value ID ' + this.valueId);

              this.newLink = "/educationmodules;view=Brand;brandId=" + this.valueId + ""
              console.log('newLink ' + this.newLink);
            }


            console.log( item.split('brandID='));
          }
        }

      }

    }
  }
  }

    return this.newLink;
  }

}





// WEBPACK FOOTER //
// ./src/app/banners/banners.component.ts